<template>
  <div class="solution">
    <!-- 顶部 banner -->
    <div class="banner">
      <div class="banner-inner">
        <h1 class="banner-title aw-anim">数字供销全域治理解决方案</h1>
        <p class="banner-desc aw-anim">构建供销一体化数字底座，贯通县乡村三级服务网络，实现资源、业务、监管、服务多维协同的全域数字化治理</p>
        <button class="banner-btn aw-anim" @click="onConsult">
          立即咨询
          <i class="el-icon-right"></i>
        </button>
      </div>
    </div>

    <!-- 方案简介 -->
    <section class="intro-section">
      <h2 class="section-title aw-anim">方案简介</h2>
      <div class="intro-body">
        <div class="intro-img">
          <img :src="introImg" alt="方案配图" />
        </div>
        <div class="intro-text aw-anim">
          <p>{{ introText }}</p>
        </div>
      </div>
    </section>

    <!-- 行业痛点 -->
    <section class="pain-section">
      <h2 class="section-title aw-anim">行业痛点</h2>
      <div class="pain-grid">
        <div class="pain-card aw-anim" v-for="(item, index) in painPoints" :key="index">
          <img class="pain-icon" :src="item.icon" :alt="item.title" />
          <h3 class="pain-title">{{ item.title }}</h3>
          <p class="pain-desc">{{ item.desc }}</p>
        </div>
      </div>
    </section>

    <!-- 核心能力 -->
    <section class="cap-section">
      <h2 class="section-title aw-anim">核心能力</h2>
      <div class="cap-grid">
        <div class="cap-card aw-anim" :class="{ featured: item.featured }" v-for="(item, index) in capabilities"
          :key="index">
          <img class="cap-icon" :src="item.icon" :alt="item.title" />
          <h3 class="cap-title">{{ item.title }}</h3>
          <p class="cap-desc">{{ item.desc }}</p>
        </div>
      </div>
    </section>

    <!-- 客户价值 -->
    <section class="value-section">
      <h2 class="section-title aw-anim">客户价值</h2>
      <div class="value-body">
        <div class="value-text aw-anim">
          <p>{{ valueText }}</p>
        </div>
        <div class="value-img">
          <img :src="valueImg" alt="客户价值全景" />
        </div>
      </div>
    </section>
    <!-- 在线留言 -->
    <ContactMessageForm />
  </div>
</template>

<script>
import ContactMessageForm from "@/components/ContactMessageForm.vue";

export default {
  name: "SolutionPage1",
  components: { ContactMessageForm },
  data() {
    return {
      introImg: require("@/assets/solution/digitalSupply/intro_mock.png"),
      valueImg: require("@/assets/solution/digitalSupply/value_mock.png"),
      introText: "基于云稼产业互联网平台底层架构，深度适配各级供销社数字化改革需求，聚焦供销体系农资供应、农业社会化服务、农产品产销三大核心主业，打造覆盖\"县-乡-网点\"三级联动的全域数字化治理平台。整合产业监管、项目运营、生态协同、数据上报全能力，依托数据孪生与产业驾驶舱，实现供销产业可视、可管、可溯、可评，构建现代化数字供销生态体系",
      valueText: "一站式整合供销全业务场景，彻底解决系统碎片化问题，降低数字化建设与运维成本；实现供销产业全流程数字化留痕、智能化监管、可视化决策，高效适配各级监管上报要求；打通内外产业协同链路，提升基层服务能力与产业运营效率，助力供销体系数字化改革落地",
      painPoints: [
        {
          icon: require("@/assets/solution/digitalSupply/sol_isol_pain1.png"),
          title: "网点分散独立",
          desc: "供销多级网点分散独立，业务、数据、人员管理割裂，无统一管控载体，数据统计滞后、失真",
        },
        {
          icon: require("@/assets/solution/digitalSupply/sol_isol_pain2.png"),
          title: "系统零散建设",
          desc: "三大主业业务系统零散建设，无法互联互通，存在大量数据孤岛，重复建设成本高",
        },
        {
          icon: require("@/assets/solution/digitalSupply/sol_isol_pain3.png"),
          title: "无可视化呈现",
          desc: "产业态势无可视化呈现，管理层无法实时掌握全域农资、农服、产销情况",
        },
        {
          icon: require("@/assets/solution/digitalSupply/sol_isol_pain4.png"),
          title: "线上化程度低",
          desc: "基层服务线上化程度低，供需匹配效率差，行业监管、数据上报、项目考核缺乏数字化支撑",
        }
      ],
      capabilities: [
        {
          icon: require("@/assets/solution/digitalSupply/sol_cap1.png"),
          title: "全域基座能力",
          desc: "依托统一租户、权限、组织体系，实现多级供销组织隔离管理，适配区域规模化部署",
          featured: true,
        },
        {
          icon: require("@/assets/solution/digitalSupply/sol_cap2.png"),
          title: "三大主业全覆盖",
          desc: "农资进销存保供管理、农事服务派单履约、农产品产销帮扶、全流程数字化",
          featured: false,
        },
        {
          icon: require("@/assets/solution/digitalSupply/sol_cap3.png"),

          title: "产业治理能力",
          desc: "供销主体管理、重点项目运营、产业态势监测、政策服务、招商协同、考核评价",
          featured: false,
        },
        {
          icon: require("@/assets/solution/digitalSupply/sol_cap4.png"),
          title: "数据智能能力",
          desc: "供销专属数据驾驶舱、多维度报表分析、自动数据上报、异常态势智能预警",
          featured: false,
        },

        {
          icon: require("@/assets/solution/digitalSupply/sol_cap5.png"),
          title: "多端协同能力",
          desc: "政府管理后台、网点运营端、农户服务小程序、移动端工作台全覆盖",
          featured: false,
        },
      ],
    };
  },
  methods: {
    onConsult() {
      const el = document.getElementById("message-section");
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        window.location.hash = "#message-section";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.solution {
  width: 100%;
  background: #ffffff;
}

/* ============ 顶部 banner ============ */
.banner {
  width: 100%;
  height: 564px;
  background-image: url("~@/assets/solution/digitalSupply/banner.png");
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

.banner-inner {
  width: 1196px;
  margin: 0 auto;
  padding-top: 150px;
  font-size: 0;
}

.banner-title {
  font-size: 44px;
  font-weight: 700;
  color: #2e6be6;
  margin: 0 0 12px;
}

.banner-desc {
  width: 610px;
  font-size: 18px;
  line-height: 31px;
  color: #333333;
  margin: 0 0 80px;
}

.banner-btn {
  display: inline-flex;
  align-items: center;
  height: 44px;
  padding: 0 28px;
  background: #3982f7;
  color: #ffffff;
  font-size: 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #2e6be6;
  }

  .btn-arrow {
    width: 16px;
    height: 16px;
    margin-left: 8px;
  }
}

/* ============ 公共标题 ============ */
.section-title {
  margin-bottom: 40px;
  text-align: center;
  line-height: 32px;
}

/* ============ 方案简介 ============ */
.intro-section {
  padding: 80px 0;
  background: #f5f8fe;
}

.intro-body {
  width: 1196px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 140px;
}

.intro-img {
  //   flex: 0 0 518px;

  img {
    width: 518px;
    height: 345px;
    display: block;
  }
}

.intro-text {
  flex: 1;

  p {
    font-size: 16px;
    line-height: 28px;
    color: #333333;
    text-align: justify;
    margin: 0;
  }
}

/* ============ 行业痛点 ============ */
.pain-section {
  padding: 80px 0;
  background: #ffffff;
}

.pain-grid {
  width: 1196px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.pain-card {
  background: #f5f8fe;
  border-radius: 12px;
  //   padding: 44px 28px;/
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  //   justify-content: center;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  padding: 32px 24px 12px 32px;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 12px 28px rgba(51, 81, 130, 0.1);
  }
}

.pain-icon {
  width: 68px;
  height: 68px;
  margin-bottom: 24px;
}

.pain-title {
  font-size: 20px;
  font-weight: 500;
  color: #333333;
  margin: 0 0 16px;
  line-height: 20px;
}

.pain-desc {
  font-size: 16px;
  line-height: 28px;
  color: #666;
  margin: 0;
  text-align: justify;
  text-align-last: center;
}

/* ============ 核心能力 ============ */
.cap-section {
  padding: 80px 0;
  background: #f5f8fe;
}

.cap-grid {
  width: 1196px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 20px;
}

.cap-card {
  grid-column: span 2;
  background: #ffffff;
  //   border: 1px solid #eef1f6;
  border-radius: 8px;
  padding: 32px 24px 0 32px;
  display: flex;
  flex-direction: column;
  //   align-items: center;
  //   justify-content: center;
  height: 250px;
  transition: transform 0.25s ease, box-shadow 0.25s ease;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 12px 28px rgba(51, 81, 130, 0.1);
  }

  /* 前两张各占半行 */
  &:nth-child(1),
  &:nth-child(2) {
    grid-column: span 3;
  }

  /* 第一张：蓝色渐变底 */
  &.featured {
    border: none;
    background: url("~@/assets/solution/bg1.png");
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
  }
}

.cap-icon {
  width: 68px;
  height: 68px;
  margin-bottom: 24px;
}

.cap-title {
  font-size: 20px;
  font-weight: 500;
  color: #333333;
  line-height: 30px;
  margin: 0 0 16px;
}

.cap-desc {
  font-size: 16px;
  line-height: 24px;
  color: #333333;
  margin: 0;
}

/* ============ 客户价值 ============ */
.value-section {
  padding: 80px 0;
  background: #ffffff;
}

.value-body {
  width: 1196px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 140px;
}

.value-text {
  flex: 1;

  p {
    font-size: 16px;
    line-height: 28px;
    color: #333333;
    text-align: justify;
    margin: 0;
  }
}

.value-img {
  img {
    width: 518px;
    height: 302px;
    display: block;
  }
}
</style>